import { ViewOrdersToggleFilterCountType, ViewOrdersToggleFilterType } from "../../features/primaryOrder/PrimaryOrder";
import "./ViewOrdersToggleFilter.css";

interface ViewOrdersToggleFilterProps {
  filterOptions: ViewOrdersToggleFilterType[];
  selectedFilters: string;
  countRecord: ViewOrdersToggleFilterCountType;
  updateFilterSelection: (option: ViewOrdersToggleFilterType) => void;
}

const ViewOrdersToggleFilter: React.FC<ViewOrdersToggleFilterProps> = ({
  filterOptions,
  selectedFilters,
  countRecord,
  updateFilterSelection,
}) => {

  const checkFilterAppliedForOption = (type: string) => {
    return selectedFilters.includes(type) ;
  };

  const totalFilterTypes = Object.keys(filterOptions).length;

  return (
    <div className="viewOrdersToggleFilterWrapper">
      <div className="ViewOrdersToggleFilter-catalogue-filters-container">
            <div className="ViewOrdersToggleFilter-catalogue-filters-row">
              <div className="ViewOrdersToggleFilter-filter-type-container">
                {filterOptions?.map((option: any, index: number) => {
                  return (
                    <div
                      className={`ViewOrdersToggleFilter-option-box ${
                        checkFilterAppliedForOption(option) && "ViewOrdersToggleFilter-active-filter"
                      }`}
                      key={option}
                      onClick={() => updateFilterSelection(option)}
                    >
                    {`${option} (${countRecord[option as keyof ViewOrdersToggleFilterCountType]})`}
                    </div>
                  );
                })}
              </div>
            </div>
      </div>
    </div>
  );
};

export default ViewOrdersToggleFilter;
